// Change these two durations for local testing; neither depends on Flagsmith values.
export const SESSION_INACTIVITY_MS = 5 * 60 * 1000; // 5 minutes
export const SESSION_WARNING_MS = 60 * 1000; // 1 minute
export const SESSION_COUNTDOWN_REFRESH_MS = 1000; // 1 second
